export const ROLE_OPTIONS = [
  { label: 'Internal', value: 'internal', description: 'Internal Zappy access' },
  { label: 'Investor', value: 'investor', description: 'Investor Zappy access' },
  {
    label: 'Venue',
    value: 'venue',
    description: 'Venue Zappy access',
  },
];
